<div [attr.data-cy]="'document-row-container_' + document.docname" class="mb-5">

    <div [attr.data-cy]="'status-message-toggle-button_' + document.docname" (click)="toggleFolderContainer(document.docid)" class="columns card is-clickable is-flex has-round-border z-index-1 px-4 py-0 h-55 hover-container">
        <div class="column is-6">
            <p>{{getLongName(document.docname)}}</p>
        </div>

      <div class="column is-flex is-justify-content-end is-align-items-center">
        <div data-cy="customer-interaction-icon" *ngIf="customerInteractions && customerInteractions.length > 0 && hasRelevantCustomerInteraction()"
             (click)="navigateToCustomerInteraction($event)" class="is-flex icon-24-px">
            <img alt="CI Icon" src="assets/images/InfoIcon/ci_info_icon.svg">
        </div>

        <div *ngIf="!isLoadingStatusMessages && statusMessages.length > 0" class="is-flex is-justify-content-end is-align-items-center ml-3">
          <img data-cy="status-message-info-icon" alt="Status Icon" src="{{StatusMessageUtils.getImageForStatusMessage(isLoadingStatusMessages, statusMessages)}}">
        </div>

        <ng-container *ngIf="!document.isLoadingFilesAndFolder; else loadingIcon">
          <ng-container *ngIf="hasDocumentFiles()">
            <div class="is-flex is-justify-content-center is-align-items-center ml-3"
                 (click)="hasDownloadPermissions() ? downloadByDocument(document, $event) : $event.stopPropagation()"
                 [matTooltip]="showToolTip()">
              <img data-cy="download-icon" alt="Download Icon" src="assets/images/download_icon/download_icon_light.svg">
            </div>
          </ng-container>
        </ng-container>

        <ng-template #loadingIcon>
          <div data-cy="status-message-loading-icon">
            <ngx-skeleton-loader [theme]="{'width':'30px','height':'30px', 'margin-top':'10px'}" appearance="circle"
                                 count="1"></ngx-skeleton-loader>
          </div>
        </ng-template>

        <ng-container *ngIf="isLoadingStatusMessages" [ngTemplateOutlet]="loadingIcon"></ng-container>
      </div>
    </div>

    <div [attr.data-cy]="'status-message-container_' + document.docname" [attr.document-id]="document.docid" class="folder-container columns card">
      <app-status-message #statusMessageComponent [statusMessages]="statusMessages" [isLoadingStatusMessages]="isLoadingStatusMessages"
                          [isHidden]="hasDocumentFiles()"
                          [property]="property"
                          [customerInteractions]="property.customerInteractions"
                          [statusMessageInitializationError]="statusMessageInitializationError"
                          [documents]="[document]">
      </app-status-message>

      <ul class="menu-list w-100 mt-5">
          <ng-container *ngFor="let folder of document.folders">
              <app-file-explorer-position [folder]="folder" [files]="folder.files"></app-file-explorer-position>
          </ng-container>
          <ng-container *ngFor="let file of document.files">
            <li class="columns" style="width: 100%" *ngIf="file.documentFolderId === null || file.documentFolderId === 0">
              <div class="column is-narrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="11.192" height="14.923"
                     viewBox="0 0 11.192 14.923">
                  <path id="Pfad_615" data-name="Pfad 615"
                        d="M5.3,7.464A2.812,2.812,0,0,1,5.243,6.1C5.488,6.1,5.465,7.173,5.3,7.464ZM5.252,8.84a13.449,13.449,0,0,1-.828,1.827,10.732,10.732,0,0,1,1.833-.638A3.775,3.775,0,0,1,5.252,8.84ZM2.509,12.477c0,.023.385-.157,1.017-1.172A4.028,4.028,0,0,0,2.509,12.477ZM7.228,4.663h3.964v9.56a.7.7,0,0,1-.7.7H.7a.7.7,0,0,1-.7-.7V.7A.7.7,0,0,1,.7,0H6.529V3.964A.7.7,0,0,0,7.228,4.663ZM6.995,9.67A2.925,2.925,0,0,1,5.75,8.1a4.189,4.189,0,0,0,.181-1.871.73.73,0,0,0-1.393-.2,4.846,4.846,0,0,0,.236,2.244,27.368,27.368,0,0,1-1.189,2.5s0,0-.006,0c-.79.405-2.145,1.3-1.588,1.982a.906.906,0,0,0,.627.291c.522,0,1.04-.525,1.781-1.8a16.613,16.613,0,0,1,2.3-.676,4.417,4.417,0,0,0,1.865.568A.754.754,0,0,0,9.14,9.88C8.735,9.484,7.557,9.6,6.995,9.67Zm3.993-6.61L8.132.2a.7.7,0,0,0-.5-.2H7.461V3.731h3.731V3.553A.7.7,0,0,0,10.988,3.06ZM8.828,10.5c.119-.079-.073-.347-1.247-.262C8.662,10.7,8.828,10.5,8.828,10.5Z"
                        fill="#b30c00"/>
                </svg>
              </div>
              <div class="column has-text-left is-narrow">
                <p class="is-clickable"
                   (click)="hasDownloadPermissions() ? downloadDocumentFile(file.id) : $event.stopPropagation()" [matTooltip]="showToolTip()">{{file.fileName}}</p>
              </div>
            </li>
          </ng-container>
      </ul>

      <ng-container *ngIf="document && isBauakDocument(document.docname)">
        <div *ngIf="document.docname === 'pbauak'" class="card content has-round-border background-is-gray p-4 w-100 is-size-7 mt-5">
          <h5>Bestellumfang</h5>
          <ul>
            <!-- First loop: everything except SONST -->
            <ng-container *ngFor="let subInformation of document.subInformations">
              <li *ngIf="subInformation.nameShort !== 'SONST'">
                <b>{{ subInformation.nameLong }}</b>
              </li>
            </ng-container>

            <!-- Then: SONST as last element (if present) -->
            <ng-container *ngFor="let subInformation of document.subInformations">
              <li *ngIf="subInformation.nameShort === 'SONST'">
                <b>{{ subInformation.nameLong }}:</b>
                <span *ngIf="document.additionalConstructionFileData?.partDescription">
                  {{ document.additionalConstructionFileData.partDescription }}
                </span>
              </li>
            </ng-container>
          </ul>
        </div>

        <div *ngIf="document.additionalConstructionFileData?.constructionYear && document.additionalConstructionFileData?.constructionYear.trim().length > 0" class="card content has-round-border background-is-gray p-4 w-100 is-size-7">
          <h5>Baujahr</h5>
          <p>{{ document.additionalConstructionFileData?.constructionYear }}</p>
        </div>

        <ng-container *ngIf="document.additionalConstructionFileData?.additionalInfo && document.additionalConstructionFileData?.additionalInfo.trim().length > 0">
          <div class="card content has-round-border background-is-gray p-4 w-100 is-size-7">
            <h5>Sonstige Anmerkungen</h5>
            <p>{{document.additionalConstructionFileData?.additionalInfo}}</p>
          </div>
        </ng-container>

        <div class="columns">
          <div class="column is-half" [ngClass]="hasAdditionalServices(document.selectedServices) ? '' : 'is-full'">
            <div class="card content has-round-border background-is-gray p-4 is-size-7">
              <h5 class="is-flex is-align-items-center">
                Kopierservice
                <img class="ml-2" width="15" height="15" src="assets/images/InfoIcon/info_icon.svg" alt="Info Icon"
                    matTooltip="Bitte beachten Sie, dass nicht jede Behörde der Aufnahme von Fotos zustimmt und entsprechend in einigen Fällen der Kopierservice genutzt werden muss. Gegenüberstellend gibt es Behörden, die keinen Kopierservice anbieten und entsprechend die Aufnahme von Scanfotos durchgeführt wird."
                    matTooltipPosition="above"
                />
              </h5>

              <ul>
                <li *ngFor="let service of copyService">
                  <p>
                    {{ NameFinderUtils.getServiceLongName(this.bookableServicesByCategory, service.nameShort) }}
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div class="column is-half" *ngIf="hasAdditionalServices(document.selectedServices)">
            <div class="card content has-round-border background-is-gray p-4 is-size-7">
              <h5>Zusatzservices</h5>
              <ul *ngIf="namingService">
                <li>
                  <p>
                    {{ NameFinderUtils.getServiceLongName(this.bookableServicesByCategory, namingService.nameShort) }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </ng-container>

      <ng-container *ngIf="!document.isLoadingFilesAndFolder; else loadingFilesAndFolders">
          <ng-container *ngIf="document.folders.length < 1">
              <div class="card has-round-border background-is-gray p-4 w-100 is-size-7 mt-3" *ngIf="document.files.length < 1">
                  <span>Aktuell sind keine Dokumente verfügbar.</span>
              </div>
          </ng-container>
      </ng-container>

      <ng-template #loadingFilesAndFolders>
        <ng-container *ngFor="let _ of [].constructor(3)">
          <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'100%'}"
                               appearance="line" count="1">
          </ngx-skeleton-loader>
        </ng-container>
      </ng-template>
    </div>
</div>
